import { IdentityDocumentPhoto, IdentityDocumentPhotoSide } from '@mews-commander/data-access';
import { LocalizedText, lt, showSuccessAlert, useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconButton, IconName, Image as ImageComponent, Stack, Typography } from '@optimus-web/core';
import { useDeleteIdentityDocumentPhotoMutation } from '../graphql/useDeleteIdentityDocumentScanPhoto';
import { downloadImage } from './identityDocumentScanDownload';

interface IdentityDocumentScanPreviewProps {
    identityDocumentId: string | null | undefined;
    scan: IdentityDocumentPhoto;
    ownerId: string;
    updateDocument: () => void;
}

export const IdentityDocumentScanPreview = ({
    identityDocumentId,
    scan,
    ownerId,
    updateDocument,
}: IdentityDocumentScanPreviewProps) => {
    const localize = useLocalizeText();

    const { id: scanId, imageUrl, name, side } = scan;
    const headerTextKey = side === IdentityDocumentPhotoSide.Front ? TextKey.FrontScan : TextKey.BackScan;
    const src = imageUrl == null ? '' : imageUrl;
    const fileName = name ?? localize({ textKey: headerTextKey });

    const { mutateAsync: deleteIdentityDocumentScan } = useDeleteIdentityDocumentPhotoMutation();
    const onDeleteScan = async () => {
        if (identityDocumentId == null || scanId == null) {
            return;
        }
        await deleteIdentityDocumentScan({
            id: scanId,
            identityDocumentId,
            guestId: ownerId,
        });
        showSuccessAlert({
            title: lt('VerificationPhotoDeleteSuccessDialogMessage'),
        });
        // This is not ideal solution, we plan on moving to Gql soon so this is just solution that works for now
        updateDocument();
    };

    return (
        <Stack vertical spacing="100">
            <Typography textStyle="bodyMediumStrong" whiteSpace="nowrap" as="h4">
                <LocalizedText textKey={headerTextKey} />
            </Typography>
            <Stack vertical spacing="100">
                <ImageComponent
                    src={src}
                    alt={localize({ textKey: headerTextKey })}
                    placeholderProps={{ minHeight: 210 }}
                    rounded
                />
                {imageUrl != null ? (
                    <Stack spacing="100" alignment="end">
                        <IconButton
                            type="button"
                            accessibleText={lt(TextKey.Download)}
                            icon={IconName.Download}
                            variant="ghost"
                            onClick={() => downloadImage({ imageUrl, fileName, watermark: true })}
                        />
                        <IconButton
                            type="button"
                            accessibleText={lt(TextKey.Delete)}
                            icon={IconName.Delete}
                            variant="ghost"
                            onClick={onDeleteScan}
                        />
                    </Stack>
                ) : null}
            </Stack>
        </Stack>
    );
};
